import { useGetBingConnectUrlMutation } from 'modules/network-accounts/api/bing-connect.api';
import useWorkspace from 'store/redux/hooks/useWorkspace';

const useBingLogin = (props) => {
  const [getBingConnectUrlQuery, { isLoading }] = useGetBingConnectUrlMutation();
  const {
    workspace: { is_demo },
  } = useWorkspace();

  /**
   * Gets the url for bing connection
   * @returns {Promise<string>}
   */
  const openBingLoginDialogAndGetData = () => {
    return getBingConnectUrlQuery()
      .unwrap()
      .then((data) => {
        if (data.url) {
          return data.url;
        }
      });
  };

  const openBingLogin = () => {
    if (is_demo) {
      window.alert("You can't connect accounts on demo account");
      return;
    }

    return openBingLoginDialogAndGetData().then((url) => {
      window.bingConnectionWindow = window.open(
        url,
        'Bing Login',
        'width=800,height=600,left=200,top=200'
      );
    });
  };

  const loadSdk = () => {};

  return {
    loading: isLoading,
    loadSDK: loadSdk,
    openLogin: openBingLogin,
    connectLoading: isLoading,
  };
};

export default useBingLogin;
